const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');
const { REWARDED_VIDEO_LOOTPACK_PLATFORMS } = require('../constants');
const { getProvider } = require('./platform');

/**
 * @return Promise that returns all available loots.
 */
function fetchLoots(apiUrl, { country, platform } = {}) {
  const query = {
    country: country || '',
    platform: platform || '',
    lang: getApiLanguage(),
    rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
  };
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v4/loots',
    query,
    expectedStatus: 200,
    description: 'Fetching loots',
  });
}

function fetchLoot(apiUrl, lootId, { country, platform } = {}) {
  const query = {
    country: country || '',
    platform: platform || '',
    lang: getApiLanguage(),
    rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
  };
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `v1/loots/${lootId}`,
    query,
    expectedStatus: 200,
    description: 'Fetchin loot',
  });
}

function createPurchase(apiUrl, token, lootId, paymentDetails) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/loots/${lootId}/purchases`,
    query: { lang: getApiLanguage() },
    body: paymentDetails,
    expectedStatus: 200,
    description: 'Creating purchase',
  });
}

function createBundlePurchase(apiUrl, token, lootId, paymentDetails) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/loots/${lootId}/bundle-purchase`,
    query: { lang: getApiLanguage() },
    body: paymentDetails,
    expectedStatus: 200,
    description: 'Creating bundle purchase',
  });
}

function confirmPurchase(apiUrl, token, lootId, transactionId, paymentDetails) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/loots/${lootId}/purchases/${transactionId}`,
    query: { lang: getApiLanguage() },
    body: paymentDetails,
    expectedStatus: 200,
    description: 'Confirming purchase',
  });
}

function createSubscription(apiUrl, token, lootId, paymentDetails) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/loots/${lootId}/subscriptions`,
    query: { lang: getApiLanguage() },
    body: paymentDetails,
    expectedStatus: 200,
    description: 'Creating subscription',
  });
}

function getAvailability(apiUrl, token, lootId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: `v1/loots/${lootId}/availability`,
    expectedStatus: 200,
    description: 'Getting loot availability',
  });
}

function confirmSubscription(
  apiUrl,
  token,
  lootId,
  transactionId,
  paymentDetails,
) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/loots/${lootId}/subscriptions/${transactionId}`,
    query: { lang: getApiLanguage() },
    body: paymentDetails,
    expectedStatus: 200,
    description: 'Confirming subscription',
  });
}

module.exports = {
  fetchLoots,
  fetchLoot,
  createPurchase,
  createBundlePurchase,
  confirmPurchase,
  createSubscription,
  confirmSubscription,
  getAvailability,
};
